

import React from 'react';
import EnhancedSwitch from '../enhanced-switch/EnhancedSwitch';
import ClassNames from 'classnames';
import CheckboxOutline from 'components/svg-icons/toggle-check-box-outline-blank';
import CheckboxChecked from 'components/svg-icons/toggle-check-box-checked';

export default React.createClass({



    propTypes: {
        onCheck: React.PropTypes.func,
        status: React.PropTypes.string
    },

    render() {

        let { onCheck } = this.props;

        let classes = ClassNames("lui-checkbox" , `lui-is-${this.props.status}`);

        let checkboxElement = (
            <div>
                <CheckboxOutline className="lui-checkbox-box" />
                <CheckboxChecked className="lui-checkbox-check" />
            </div>
        );

        let enhancedSwitchProps = {
            ref: "enhancedSwitch",
            inputType: "checkbox",
            switchElement: checkboxElement,
            className: classes,
            iconClassName: "lui-checkbox-icon",
            onSwitch: this._handleCheck,
            labelPosition: (this.props.labelPosition) ? this.props.labelPosition : "right"
        };

        return (
            <EnhancedSwitch
                {...this.props}
                {...enhancedSwitchProps} />
        );
    },

    isChecked() {
        return this.refs.enhancedSwitch.isSwitched();
    },

    setChecked(newCheckedValue) {
        this.refs.enhancedSwitch.setSwitched(newCheckedValue);
    },

    _handleCheck(e, isInputChecked) {
        if (this.props.onCheck) this.props.onCheck(e, isInputChecked);
    }

});



/** WEBPACK FOOTER **
 ** ./src/components/forms/checkbox/Checkbox.js
 **/